import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { IconButton, TextField } from '@mui/material'
import {
  Chat as ChatIcon,
  Close as CloseIcon,
  Send as SendIcon,
  AttachFile as AttachFileIcon,
  Person as UserIcon,
  Assistant as BotIcon
} from '@mui/icons-material'

const AppChatBot = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const selectedApplicationData = useSelector(
    state => state.intakeData.selectedApplicationData
  )

  const [chatHistory, setChatHistory] = useState([
    {
      type: 'answer',
      content: `first message`
    }
  ])
  useEffect(() => {
    if (selectedApplicationData) {
      setChatHistory([
        {
          type: 'answer',
          content: `Hi! How can I assist you with the applicant <strong>${selectedApplicationData['applicant_info'].name}(${selectedApplicationData['application_id']})</strong>`
        }
      ])
    }
  }, [selectedApplicationData])

  const chatContainerRef = useRef(null)

  const toggleChatBot = () => {
    setIsOpen(!isOpen)
  }

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight
    }
  }

  useEffect(() => {
    scrollToBottom()
  }, [chatHistory])

  const handleSendMessage = async () => {
    if (!message.trim() || loading) return

    const newChatHistory = [
      ...chatHistory,
      { type: 'question', content: message },
      { type: 'answer', content: 'loading' } // Placeholder for bot's typing effect
    ]

    setChatHistory(newChatHistory)
    setLoading(true)
    setMessage('')

    try {
      const accessToken = localStorage.getItem('access_token')
      const refreshToken = localStorage.getItem('refresh_token')
      const headers = {
        'X-Access-Token': accessToken,
        'X-Refresh-Token': refreshToken,
        Accept: 'application/json'
      }

      const response = await axios.get(
        `https://insureai-bot-1074099157700.us-central1.run.app/appetite/v1/bot/appetite/chat?query=${encodeURIComponent(
          message
        )}&application_id=${encodeURIComponent(
          selectedApplicationData['application_id']
        )}`,
        { headers }
      )

      const botResponse =
        response?.data?.answer || 'No response from the server.'

      setChatHistory(prev => {
        const updatedHistory = [...prev]
        updatedHistory[updatedHistory.length - 1] = {
          type: 'answer',
          content: botResponse
        }
        return updatedHistory
      })
    } catch (error) {
      setChatHistory(prev => {
        const updatedHistory = [...prev]
        updatedHistory[updatedHistory.length - 1] = {
          type: 'error',
          content: 'Error fetching response.'
        }
        return updatedHistory
      })
    } finally {
      setLoading(false)
    }
  }

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSendMessage()
    }
  }

  return (
    <div
      className='fixed bottom-4 right-4 bg-orange-600 rounded-lg chat-bot'
      style={{ border: `2px solid ${isOpen ? '#ea580c' : 'transparent'}` }}
    >
      {!isOpen && (
        <IconButton
          onClick={toggleChatBot}
          className='bg-orange-600 text-white p-3 rounded-full shadow-lg'
          style={{ color: 'white' }}
        >
          <ChatIcon />
        </IconButton>
      )}

      {isOpen && (
        <div className='w-96 h-[32rem] bg-white rounded-lg shadow-lg flex flex-col overflow-hidden'>
          <div className='bg-orange-600 text-white p-3 flex justify-between items-center'>
            <h2 className='text-lg font-bold'>Ask Underwriting Bot</h2>
            <IconButton
              onClick={toggleChatBot}
              className='text-white'
              style={{ color: 'white', padding: '0' }}
            >
              <CloseIcon />
            </IconButton>
          </div>

          <div
            className='flex-1 p-4 overflow-y-auto space-y-4'
            ref={chatContainerRef}
          >
            {chatHistory.map((item, index) => (
              <div
                key={index}
                className={`flex items-start ${
                  item.type === 'question'
                    ? 'justify-end pl-5'
                    : 'justify-start'
                }`}
              >
                {item.type === 'answer' && (
                  <BotIcon className='mr-2 text-orange-600' />
                )}
                {item.type === 'question' && (
                  <UserIcon className='mr-2 text-blue-500' />
                )}
                {item.content === 'loading' ? (
                  <div className='flex space-x-1'>
                    <span className='w-2 h-2 bg-orange-600 rounded-full animate-bounce'></span>
                    <span className='w-2 h-2 bg-orange-600 rounded-full animate-bounce animation-delay-200'></span>
                    <span className='w-2 h-2 bg-orange-600 rounded-full animate-bounce animation-delay-400'></span>
                  </div>
                ) : (
                  <p
                    className={`p-2 rounded-lg ${
                      item.type === 'question'
                        ? 'bg-blue-100 text-blue-500'
                        : item.type === 'error'
                        ? 'bg-red-100 text-red-700'
                        : 'bg-gray-100 text-gray-700'
                    }`}
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  ></p>
                )}
              </div>
            ))}
          </div>

          <div className='p-3 border-t flex items-center space-x-2'>
            <IconButton color='primary' component='label'>
              <AttachFileIcon />
              <input type='file' hidden />
            </IconButton>
            <TextField
              variant='outlined'
              size='small'
              fullWidth
              value={message}
              onChange={e => setMessage(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder='Type your message...'
              disabled={loading}
            />
            <IconButton
              color='primary'
              onClick={handleSendMessage}
              disabled={loading}
            >
              <SendIcon />
            </IconButton>
          </div>
        </div>
      )}
    </div>
  )
}

export default AppChatBot
